import React, { useState, useEffect } from 'react';

import MyBusiness from '../MyBusiness/MyBusiness';
import Compare from '../Compare/Compare'
import Reports from '../Reports/Reports'
import Improvements from '../Improvements/Improvements';
import Discover from '../Discover/Discover';
import Profile from '../Profile/Profile'

import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useUser } from '../../providers/UserContext';

import './Sidebar.css'

function Sidebar() {
  const { t } = useTranslation(); // Hook para traducciones
  const { user } = useUser();
  const [usuario, setUser] = useState(null);

  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

  const [activeComponent, setActiveComponent] = useState('myBusiness');

  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  useEffect(() => {
    if (isSidebarExpanded) {
      // Acciones cuando se expande
      // console.log('Sidebar expanded');
    } else {
      // Acciones cuando se contrae
      // console.log('Sidebar collapsed');
    }
  }, [isSidebarExpanded]);

  const toggleSidebar = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
  };

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(()=>{
    const fetchData = async () => {
      try{
        var userUID = user.uid ? user.uid : localStorage.getItem("userUID")
        const response = await axios.get(`${apiUrl}/collections/user/${userUID}`);
        setUser(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    fetchData();
  }, [user]);

  return (
    <div className="page-content">
      {/* SIDEBAR */}
      <div
          className={`sidebar sidebar-main sidebar-expand-xl ${
            isSidebarExpanded ? 'sidebar-main-resized' : ''
          } ${isSidebarVisible ? 'show' : ''}`}
        >

        <button 
          type="button" 
          className={`closed-menubtn btn btn-light btn-icon btn-sm rounded-pill border-transparent sidebar-mobile-main-toggle d-xl-none ${isSidebarVisible ? 'd-none' : ''}`}
          onClick={() => setIsSidebarVisible(!isSidebarVisible)}
        >
          <i className={isSidebarVisible ? "ph-arrows-left-right" : "ph-arrows-left-right"}></i>
        </button>
        <div className="sidebar-content">
          <div className="sidebar-section">
            <div className="sidebar-section-body d-flex justify-content-center pb-1">
              <h5 className="sidebar-resize-hide flex-grow-1 my-auto">Menu</h5>
              <div>
                <button type="button" className="btn btn-light btn-icon btn-sm rounded-pill border-transparent sidebar-control sidebar-main-resize d-none d-xl-inline-flex arrows-btn"
                  onClick={toggleSidebar}>
                  <i className="ph-arrows-left-right"></i>
                </button>

                <button 
                  type="button" 
                  className="btn btn-light btn-icon btn-sm rounded-pill border-transparent sidebar-mobile-main-toggle d-xl-none x-sidebar-btn"
                  onClick={() => {
                    setIsSidebarVisible(false);
                    setIsSidebarExpanded(false); // También cierra el menú en caso de que esté expandido
                  }}
                >
                  <i className="ph-x"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="sidebar-section">
          <ul className="nav nav-sidebar" data-nav-type="accordion">
            <li className="nav-item">
              <a href="#" className={`nav-link ${activeComponent === 'myBusiness' ? 'active' : ''}`} onClick={() => setActiveComponent('myBusiness')}>
                <i className="ph-chart-bar"></i>
                <span>{t('myBusiness')}</span>
              </a>
            </li>
            <li className="nav-item">
              <a href="#" className={`nav-link ${activeComponent === 'compare' ? 'active' : ''}`} onClick={() => setActiveComponent('compare')}>
                <i className="ph-graph"></i>
                <span>{t('compare')}</span>
              </a>
            </li>
            {/* <li className="nav-item">
              <a href="#" className={`nav-link ${activeComponent === 'reports' ? 'active' : ''}`} onClick={() => setActiveComponent('reports')}>
                <i className="ph-newspaper-clipping"></i>
                <span>Reports</span>
              </a>
            </li> */}
            <li className="nav-item">
              <a href="#" className={`nav-link ${activeComponent === 'improvements' ? 'active' : ''}`} onClick={() => setActiveComponent('improvements')}>
                <i className="ph-chart-line-up"></i>
                <span>{t('reports')}</span>
              </a>
            </li>
            <li className="nav-item">
              <a href="#" className={`nav-link ${activeComponent === 'discover' ? 'active' : ''}`} onClick={() => setActiveComponent('discover')}>
                <i className="ph-projector-screen-chart"></i>
                <span>{t('discover')}</span>
              </a>
            </li>
            <li className="nav-item">
              <a href="#" className={`nav-link ${activeComponent === 'profile' ? 'active' : ''}`} onClick={() => setActiveComponent('profile')}>
                <i className="ph-user-circle"></i>
                <span>{t('profile')}</span>
              </a>
            </li>
          </ul>
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className='content-wrapper'>
        {activeComponent === 'myBusiness' && <MyBusiness selected={activeComponent === 'myBusiness'}/>}
        {activeComponent === 'compare' && <Compare selected={activeComponent === 'compare'}/>}
        {activeComponent === 'reports' && <Reports selected={activeComponent === 'reports'}/>}
        {activeComponent === 'improvements' && <Improvements selected={activeComponent === 'improvements'}/>}
        {activeComponent === 'discover' && <Discover selected={activeComponent === 'discover'}/>}
        {activeComponent === 'profile' && <Profile selected={activeComponent === 'profile'}/>}
      </div>
    </div>
  );
}

export default Sidebar;
